import { render, staticRenderFns } from "./perContractDetail.vue?vue&type=template&id=5c513b07&scoped=true&"
import script from "./perContractDetail.vue?vue&type=script&lang=js&"
export * from "./perContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./perContractDetail.vue?vue&type=style&index=0&id=5c513b07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c513b07",
  null
  
)

export default component.exports